const state = {
  loading: false,
  currentVersion: process.env.APP.version,
  land: {
    iso: process.env.APP.market_iso,
    name: process.env.APP.market_name
  },
  maxPosibleStock: 100000000,
  loaderColor: '#bf483c',
  connected: true,
  globalToastType: '',
  toastOptions: {
    'verify': {
      color: 'error',
      message: 'Du musst Deine Email-Adresse verifizieren, bevor Du einkaufen kannst!',
      icon: 'fingerprint',
      action: {
        text: 'X',
        class: 'toastBtn',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        }
      }
    },
    'connection': {
      color: 'error',
      message: 'Bitte überprüfe Deine Internetverbindung.',
      icon: 'wifi',
      action: {
        text: 'X',
        class: 'toastBtn',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        }
      }
    }
  }
}

const getters = {
  options_get_version: state => {
    return state.currentVersion
  },
  options_is_loading: state => {
    return state.loading
  },
  options_loader_color: state => {
    return state.loaderColor
  },
  options_online_status: state => {
    return state.connected
  },
  options_global_toast: state => {
    return state.globalToastType
  },
  options_toast: state => {
    return type => {
      return state.toastOptions[type]
    }
  },
  options_get_land: state => {
    return state.land
  },
  options_get_max_posible_stock: state => {
    return state.maxPosibleStock
  }
}

const mutations = {
  OPTIONS_LOADING_STARTED (state) {
    state.loading = true
  },
  OPTIONS_LOADING_ENDED (state) {
    state.loading = false
  },
  OPTIONS_SET_TOAST (state, type) {
    state.globalToastType = type
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/options.js